// 主容器
import MainContent from '@/components/tourist/common/MainContent'

import Login from '@/components/Login'
// import MainHome from '@/components/tourist/Home'
// import Advantage from '@/components/tourist/Advantage'
// import Products from '@/components/tourist/Products'
// import SuccessfulCase from '@/components/tourist/SuccessfulCase'
// import LearningAndSupport from '@/components/tourist/LearningAndSupport'
// import AboutUs from '@/components/tourist/AboutUs'
// import AboutDetails from '@/components/tourist/AboutDetails'
// import IndustryDetails from '@/components/tourist/IndustryDetails'
// import ProductDetails from '@/components/tourist/ProductDetails'
// import CaseDetails from '@/components/tourist/CaseDetails'
// import JoinUs from '@/components/tourist/JoinUs'

const routes = {
  path: '/',
  component: MainContent,
  children: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // }, {
    //   path: '/',
    //   name: 'main-home',
    //   component: MainHome
    // },
    // {
    //   path: '/advantage',
    //   name: 'advantage',
    //   component: Advantage
    // },
    // {
    //   path: '/products',
    //   name: 'products',
    //   component: Products
    // },
    // {
    //   path: '/products-details',
    //   name: 'product-details',
    //   component: ProductDetails
    // },
    // {
    //   path: '/successful-case',
    //   name: 'successful-case',
    //   component: SuccessfulCase
    // },
    // {
    //   path: '/case-details',
    //   name: 'case-details',
    //   component: CaseDetails
    // },
    // {
    //   path: '/learning-and-support',
    //   name: 'learning-and-support',
    //   component: LearningAndSupport
    // },
    // {
    //   path: '/about-us',
    //   name: 'about-us',
    //   component: AboutUs
    // },
    // {
    //   path: '/about-details',
    //   name: 'about-details',
    //   component: AboutDetails
    // },
    // {
    //   path: '/industry-details',
    //   name: 'industry-details',
    //   component: IndustryDetails
    // },
    // {
    //   path: '/join-us',
    //   name: 'join-us',
    //   component: JoinUs
    // }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/tourist/index.js